<template>
  <div
    class="group flex items-center justify-between p-1"
    :class="{
      'rounded-sm bg-disabled': name && type,
    }"
  >
    <div
      v-if="name"
      ref="businessNameRef"
      v-tooltip="{
        content: name,
        onShow: () => isBusinessNameTruncated,
      }"
      class="overflow-hidden text-xs text-ellipsis whitespace-nowrap text-label"
    >
      <span
        class="cursor-pointer"
        data-cy="messageable-deal-link"
        @click.stop="openDeal"
      >
        {{ name }}
      </span>
    </div>
    <div
      v-else
      ref="businessNameRef"
      v-tooltip="{
        content: $t('EMAIL_INTEGRATION.NO_DEAL_ASSIGNED'),
        onShow: () => isBusinessNameTruncated,
      }"
      class="overflow-hidden rounded-full border border-divider px-2 py-1 text-xxs font-medium text-ellipsis whitespace-nowrap text-silver"
    >
      {{ $t("EMAIL_INTEGRATION.NO_DEAL_ASSIGNED").toUpperCase() }}
    </div>
    <div v-if="isInboxPage" class="relative hidden group-hover:block">
      <assign-messageable-to-deal
        v-if="
          type === CommunicationType.email || type === CommunicationType.sms
        "
        :id="id"
        :application-id="applicationId"
        is-email-tab
        :name="name"
        :assign-text="t('EMAIL_INTEGRATION.REASSIGN')"
        :type="type"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { CommunicationType } from "@/enums/communicationLogs";
import { useCommunicationLogs } from "@/hooks/communicationLogs";
import { useElementStatus } from "@/hooks/elements";
import { ROUTE_DEAL_PROGRESS } from "@/router/routes";

import AssignMessageableToDeal from "@/components/communicationLogs/communication/emailThread/AssignMessageableToDeal.vue";

import type { Nullish } from "@/models/common";

interface Props {
  name: string | Nullish;
  applicationId: string | Nullish;
  id: number;
  type: CommunicationType;
}

const props = defineProps<Props>();

const { isTextTruncated } = useElementStatus();
const { isInboxPage } = useCommunicationLogs();
const router = useRouter();
const { t } = useI18n();

const businessNameRef = ref<HTMLElement | null>(null);
const isBusinessNameTruncated = isTextTruncated(businessNameRef);

const dealRoute = computed(() =>
  router.resolve({
    name: ROUTE_DEAL_PROGRESS,
    params: { id: props.applicationId },
  })
);

const openDeal = () => {
  if (!props.applicationId) {
    return;
  }

  window.open(dealRoute.value.href, "_blank");
};
</script>
